import { Box, Checkbox, Typography } from "@mui/material";
import React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontFamily: "Montserrat",
  fontSize: "16px",
  lineHeight: "150%",
  letterSpacing: "0%",
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#0A3575",
    color: theme.palette.common.white,
    height: "12px",
    fontWeight: 500,
    fontStyle: "Medium",
    padding: "7px 8px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontWeight: 600,
    fontStyle: "SemiBold",
    height: "50px",
    color: "#191E31",
    fontWeight: 600,
    padding: "16px 8px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#ffffff",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const ReportsTable = ({
  columns,
  rows,
  setData,
  auditLevel,
  setAuditLevel,
  setSelectedUser,
  selectedBox,
  setSelectedBox,
}) => {
  const handleCheckboxChange = (e, rowIndex) => {
    const { checked } = e.target;
    setData(
      rows.map((ele, index) =>
        index === rowIndex
          ? {
              ...ele,
              checked,
            }
          : ele
      )
    );
  };

  const handleSelectAll = () => {
    const newSelectedState = !selectedBox;
    setSelectedBox(newSelectedState);

    setData(
      rows.map((ele) => ({
        ...ele,
        checked: newSelectedState,
      }))
    );
  };

  return (
    <Box>
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: "75vh",
          borderRadius: "16px",
          overflow: "auto",
        }}
      >
        <Table
          stickyHeader
          sx={{ minWidth: 700 }}
          aria-label="customized table"
        >
          <TableHead sx={{ borderRadius: "10px 10px 0px 0px" }}>
            <TableRow sx={{ borderRadius: "10px 10px 0px 0px" }}>
              {columns?.map((column, index) => (
                <StyledTableCell
                  key={index}
                  align={column.field == "sno" ? "right" : "left"}
                  sx={{
                    wordWrap: "break-word",
                    overflowWrap: "break-word",
                    whiteSpace: "normal",
                    width: column.width || "auto",
                  }}
                >
                  {column.label ? (
                    column.label
                  ) : (
                    <Checkbox
                      checked={selectedBox}
                      onChange={handleSelectAll}
                      sx={{
                        "& .MuiSvgIcon-root": {
                          boxSizing: "border-box",
                          backgroundColor: "white",
                          border: "12px solid white",
                          borderRadius: "5px",
                        },
                        "&.Mui-checked .MuiSvgIcon-root": {
                          backgroundColor: "white",
                          color: "#EF7D00",
                          border: "none",
                          boxShadow: "inset 0 0 0 5px #EF7D00",
                        },
                      }}
                    />
                  )}
                </StyledTableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.map((row, rowIndex) => (
              <StyledTableRow key={rowIndex}>
                {columns?.map((column, colIndex) => (
                  <StyledTableCell
                    key={colIndex}
                    align={column.field == "sno" ? "center" : "left"}
                    width={column.width || ""}
                    sx={{
                      wordBreak: "break-word",
                      overflowWrap: "break-word",
                      whiteSpace: "normal",
                    }}
                  >
                    {column.field === "checked" ? (
                      <Checkbox
                        checked={row[column.field]}
                        onChange={(e) => handleCheckboxChange(e, rowIndex)}
                        sx={{
                          "&.Mui-checked .MuiSvgIcon-root": {
                            color: "#EF7D00",
                          },
                        }}
                      />
                    ) : column.field === "userName" && auditLevel === 0 ? (
                      <Typography
                        sx={{
                          font: "inherit",
                          letterSpacing: "inherit",
                          textDecoration: "underline",
                          textDecorationStyle: "solid",
                          color: "#007BFF",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setSelectedUser({
                            batOneId: row["batOneId"],
                            countryCode: row["countryCode"],
                            profileAttribute: row["profileAttribute"],
                          });
                          setAuditLevel(1);
                        }}
                      >
                        {row[column.field]}
                      </Typography>
                    ) : (
                      row[column.field]
                    )}
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default ReportsTable;
